module.exports = __webpack_public_path__ + "img/WEBSITE9.b3ca8ea5.webp";